// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-page-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 50px 10px 50px 80px;
    font-family: "Arial", sans-serif;
    background-color: #f8f9fa;
    height: 100vh;
    text-align: center;
}

.error-message {
    max-width: 50%;
}

.error-code {
    font-size: 4rem;
    color: #ff4e4e;
    margin: 0;
}

.text {
    font-size: 1.5rem;
    color: #1e255e;
    margin: 10px 0;
    font-weight: 600;
}

.suggestion {
    font-size: 1rem;
    color: #6c757d;
    margin-bottom: 20px;
}

.homepage-button {
    background-color: #343a40;
    color: #fff;
    padding: 10px 20px;
    font-size: 1rem;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;
}



.error-image {
    position: relative;
}

.character {
    position: relative;
    display: inline-block;
    width: 60%;
}

.speech-bubble {
    position: absolute;
    top: -50px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #ff6b6b;
    color: white;
    padding: 10px 20px;
    font-size: 1rem;
    border-radius: 20px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}

.character-image {
    max-width: 100%;
    height: auto;
}
`, "",{"version":3,"sources":["webpack://./src/reusableComponents/ErrorPages/assets/style/errorPageStyleSheet.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,4BAA4B;IAC5B,gCAAgC;IAChC,yBAAyB;IACzB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;;;AAIA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,2BAA2B;IAC3B,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,YAAY;AAChB","sourcesContent":[".error-page-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 50px 10px 50px 80px;\n    font-family: \"Arial\", sans-serif;\n    background-color: #f8f9fa;\n    height: 100vh;\n    text-align: center;\n}\n\n.error-message {\n    max-width: 50%;\n}\n\n.error-code {\n    font-size: 4rem;\n    color: #ff4e4e;\n    margin: 0;\n}\n\n.text {\n    font-size: 1.5rem;\n    color: #1e255e;\n    margin: 10px 0;\n    font-weight: 600;\n}\n\n.suggestion {\n    font-size: 1rem;\n    color: #6c757d;\n    margin-bottom: 20px;\n}\n\n.homepage-button {\n    background-color: #343a40;\n    color: #fff;\n    padding: 10px 20px;\n    font-size: 1rem;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n\n\n.error-image {\n    position: relative;\n}\n\n.character {\n    position: relative;\n    display: inline-block;\n    width: 60%;\n}\n\n.speech-bubble {\n    position: absolute;\n    top: -50px;\n    left: 50%;\n    transform: translateX(-50%);\n    background-color: #ff6b6b;\n    color: white;\n    padding: 10px 20px;\n    font-size: 1rem;\n    border-radius: 20px;\n    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.character-image {\n    max-width: 100%;\n    height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
